<template>
  <div class="my-0">
    <v-row>
      <v-col cols="12" md="12">
        <v-card
          flat
          class="border-radius">
          <v-card-text class="py-0">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="#240087"
              slider-size="4">
              <v-tabs-slider color="#240087"></v-tabs-slider>
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="text-capitalize">
                <span class="body-2" :class="tab === index ? 'font-weight-bold color-default' : 'text-third'">
                  <!-- {{ item.label }} -->
                  <div>
                    <v-badge
                      color="red"
                      :content="permintaan.total"
                      v-if="item.label === 'Permintaan' && permintaan.total > 0">
                      {{ item.label }}
                     </v-badge> 
                    <v-badge
                      color="red"
                      :content="permintaan.total"
                      v-if="item.label === 'Approval Permintaan' && permintaan.total > 0">
                      {{ item.label }}
                    </v-badge>
                    <!-- <v-badge
                      color="red"
                      :content="pengadaan.total"
                      v-if="item.label === 'Pengadaan' && pengadaan.total > 0">
                      {{ item.label }} 
                    </v-badge> -->
                    <v-badge
                      color="red"
                      :content="penerimaan.total"
                      v-if="item.label === 'Penerimaan' && penerimaan.total > 0">
                      {{ item.label }}
                    </v-badge>
                    <span v-if="item.label === 'Pengadaan'">{{ item.label }}</span>
                    <span v-if="item.label === 'Approval Permintaan' && permintaan.total < 1">{{ item.label }}</span>
                    <span v-if="item.label === 'Permintaan' && permintaan.total < 1">{{ item.label }}</span>
                    <span v-if="item.label === 'Penerimaan' && penerimaan.total < 1">{{ item.label }}</span>
                    <span v-if="item.label === 'Persediaan'">{{ item.label }}</span>
                  </div>
                </span>
              </v-tab>
            </v-tabs>
            <v-divider/>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, index) in menu"
                :key="index">
                <router-view :model="tab"/>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        tab: 0,
        permintaan: {
          total: 0
        },
        pengadaan: {
          total: 0
        },
        penerimaan: {
          total: 0
        },
        // menu: []
        //   {
        //     label: "Kategori Item",
        //     value: "/pembelian/kategori-item"
        //   },
        //   {
        //     label: "Data Item",
        //     value: "/pembelian/item"
        //   },
        //   {
        //     label: "Data Supplier",
        //     value: "/pembelian/supplier"
        //   },
        //   // {
        //   //   label: "Data Item Supplier",
        //   //   value: "/pembelian/supplier-item"
        //   // },
        // ]
      }
    },
    components: {
      
    },
    computed: {
      menu () {
        let menu
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map((item, index) => {
          if(item.link === "/pembelian") {
            // console.log(item.sub_menu)
            menu = item.sub_menu
          }
          // return item
        })
        if(this.$route.path === '/pembelian') {
          this.$router.push({ path: `${menu[0].link}` })
        } 
        // this.tab = 0
        // console.log(menu.findIndex(item => item.link === this.$route.path))
        this.tab = this.$route.path === '/pembelian' ? 0 : (menu.findIndex(item => item.link === this.$route.path))
        // this.$router.push({ path: `${menu[0].link}` })
        // this.tab = 0
        return menu
      },
      outlet () {
        return this.$store.state.outlet
      },
    },
    watch: {
      "tab": function(val) {
        this.$router.push({ path: `${this.menu[val].link}` })
      }
    },
    mounted () {
      this.fetctPermintaan()
      this.fetchPengadaan()
      this.fetchPenerimaan()
    },
    methods: {
      async fetctPermintaan () {
        let params = {
          outlet_id: this.outlet.outlet_id
        }
        
        await get('pos/pembelian/request/count', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.permintaan = res.results.data
          }
        })
      },
      async fetchPengadaan () {
        let params = {
          outlet_id: this.outlet.outlet_id
        }
        
        await get('pos/pembelian/pengadaan/count', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pengadaan = res.results.data
          }
        })
      },
      async fetchPenerimaan () {
        let params = {
          outlet_id: this.outlet.outlet_id
        }
        
        await get('pos/pembelian/penerimaan/count', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.penerimaan = res.results.data
          }
        })
      }
    }
  }
</script>